import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tourTicketActions from './../../../../actions/tourTicketAction';
import TourTicket from './TourTicket';

const mapStateToProps = state => {
    return {
        tourTicketsState: state.tourTicketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListTourTicket: (filters) => dispatch(tourTicketActions.dataTourTicketAction(filters)),
        onDeleteTourTicket: (id) => dispatch(tourTicketActions.deleteTourTicketAction(id))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TourTicket));
